(function(){
  var MAP = window.NovaColoriMap || {};
  var active = false, lastG = null;
  function picker(){ return document.querySelector('variant-picker[data-section-id*="__main"]') || document.querySelector('variant-picker'); }
  function colore(vp){
    var el = vp.querySelector('input[name^="Colore"]:checked') || vp.querySelector('input[name^="Colore"][aria-checked="true"]');
    if (el) return el.value;
    var s = vp.querySelector('select[name^="Colore"]');
    return s ? s.value : null;
  }
  function apply(){
    var vp = picker(); if (!vp) return;
    var m = MAP[vp.getAttribute('data-product-id')]; if (!m) return;
    var c = colore(vp); if (c == null || m[c] == null) return;
    var g = document.querySelector('media-gallery'); if (!g) return;
    lastG = g;
    var i = m[c];
    var grid = g.querySelector('.media-gallery__grid');
    if (grid && grid.getBoundingClientRect().width > 0) {
      var items = grid.children;
      if (!items[i]) return;
      for (var k = 0; k < items.length; k++) items[k].style.order = '';
      items[i].style.order = '-1';
      var r = g.getBoundingClientRect();
      if (r.top < -40) window.scrollTo({ top: window.scrollY + r.top - 90, behavior: 'smooth' });
    } else {
      var ss = g.querySelector('slideshow-component');
      if (ss && typeof ss.select === 'function') { try { ss.select(i); } catch (e) {} }
    }
  }
  function later(){ active = true; setTimeout(apply, 60); setTimeout(apply, 700); }
  document.addEventListener('change', function(e){
    if (e.target && e.target.closest && e.target.closest('variant-picker')) later();
  }, true);
  var t;
  new MutationObserver(function(){
    if (!active) return;
    var g = document.querySelector('media-gallery');
    if (g && g !== lastG) { clearTimeout(t); t = setTimeout(apply, 80); }
  }).observe(document.body, { childList: true, subtree: true });
  if (/[?&]variant=/.test(location.search)) { active = true; window.addEventListener('load', function(){ setTimeout(apply, 300); }); }
})();
